import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBankAccount = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 42,
	height: 42,
	viewBox: "0 0 42 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 21,
			cy: 21.0039,
			r: 21,
			fill: "#E9FEF5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 21.6138H28",
			stroke: "#0DC277",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28 19.2837V26.4337C27.97 29.2837 27.19 30.0037 24.22 30.0037H14.78C11.76 30.0037 11 29.2537 11 26.2737V19.2837C11 16.5837 11.63 15.7137 14 15.5737C14.24 15.5637 14.5 15.5537 14.78 15.5537H24.22C27.24 15.5537 28 16.3037 28 19.2837Z",
			stroke: "#0DC277",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31 15.7339V22.7239C31 25.4239 30.37 26.2939 28 26.4339V19.2839C28 16.3039 27.24 15.5539 24.22 15.5539H14.78C14.5 15.5539 14.24 15.5639 14 15.5739C14.03 12.7239 14.81 12.0039 17.78 12.0039H27.22C30.24 12.0039 31 12.7539 31 15.7339Z",
			stroke: "#0DC277",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.25 26.814H15.97",
			stroke: "#0DC277",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.1094 26.814H21.5494",
			stroke: "#0DC277",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgBankAccount;
